import React from 'react';
import styled from 'styled-components';
import Logo from './Logo';
import Search from './Search';
import Navigation from './Navigation';
import { Link, LinkProps } from 'react-router-dom';

const HeaderContainer = styled.header`
  position: sticky;
  top: 0;
  z-index: 100;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: #fff;
  display: grid;
  grid-template-areas: "logo navigation"
                       "search search";
  row-gap: 15px;
  padding: 20px 10px;


  @media (min-width: 768px) {
    grid-template-areas: "logo search navigation";
    grid-template-columns: 140px minmax(auto, 500px) 140px;
  }
`;

const StyledLink = styled(Link)<LinkProps>`
  grid-area: logo;
`;

const LogoContainer = styled.div`
  width: 140px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: left;
`;

const Header: React.FC = React.memo(() => {
  return (
    <HeaderContainer>
      <StyledLink to={{pathname: "/"}}>
        <LogoContainer>
          <Logo />
        </LogoContainer>
      </StyledLink >

      <Search />
      <Navigation />
    </HeaderContainer>
  );
});

export default Header;